<template>
  <b-row>
    <b-col cols="12">
        <!-- <h2 class="align-self-center my-0 v2_font_weight_semibold v2_font_size_24 mb-4">
          Payment
        </h2> -->
      <!-- <b-row>
        <b-col>
          Thank you for your company information. Complete this payment page to purchase "Connect".
        </b-col>
      </b-row> -->
      <!-- <b-row class="mt-4">
        <b-col>
            Here’s what’s included: 
          <p class="mb-0"><i class="mdi mdi-18px mdi-check"></i>Access to specialty-specific compensation and productivity data to inform your offer.</p>
          <p class="mb-0"><i class="mdi mdi-18px mdi-check"></i>Immediate delivery of your job opportunity to all interested candidates.</p>
          <p class="mb-0"><i class="mdi mdi-18px mdi-check"></i>Our algorithm searches for and includes any new matching candidates for  {{ this.job_opportunity_duration }} days.</p>
          <p class="mb-0"><i class="mdi mdi-18px mdi-check"></i>Instant candidate feedback and communications delivered to your Dashboard.</p>
        </b-col>
      </b-row> -->
      <b-row class="mt-4">
        <b-col>
          <p class="mb-0">
            To purchase Phairify using a credit card, you must provide 
            Phairify with a valid credit card. If applicable, enter your 
            ‘coupon code’ to secure any special and agreed pricing.
          </p>
      </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          By clicking “Complete Order” I agree that I have read and accepted the
        <a
            href="https://phairify-docs.s3.us-east-2.amazonaws.com/Phairify_Terms_Conditions_Use.pdf"
            target="_blank"
        >
          Terms of Use</a>. See our <a
          href="https://phairify-docs.s3.us-east-2.amazonaws.com/Phairify_Privacy_Policy_2020_09_01.pdf"
          target="_blank"
      > Privacy Policy </a> for details or to opt out at any time.
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <div
            v-if="stripeErrors"
            class="invalid-feedback"
            :class="{ 'd-block': !!stripeErrors }"
          >
            {{ stripeErrors }}
          </div>
          <b-row class="mt-2">
            <b-col cols="8">
              <b-form-group label="Card Number *">
                <div class="form-control d-flex align-items-center">
                  <div ref="cardNumber" class="flex-grow-1"></div>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="CVV *">
                <div class="form-control d-flex align-items-center">
                  <div ref="cardCvc" class="flex-grow-1"></div>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              <b-form-group
                label="Card Holder Name *"
                :invalid-feedback="cardHolderNameInvalidFeedback"
                :state="validateState('cardHolderName')"
              >
                <b-form-input
                  v-model="$v.cardHolderName.$model"
                  type="text"
                  required
                  :state="validateState('cardHolderName')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              <b-form-group label="Expiration Date *">
                <div class="form-control d-flex align-items-center">
                  <div ref="cardExpiry" class="flex-grow-1"></div>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="8">
                  <b-form-group label="Customer Code">
                    <b-form-input v-model="couponCode" type="text" />
                  </b-form-group>
                </b-col>
                <!-- <b-col cols="2" class="mt-4">
                    <button class="btn btn btn-next btn-primary" @click="applyCouponCodeDiscount" :disabled="isDisabledApplyBtn">Apply</button>
                </b-col>
                <b-col cols="1" class="mt-4">
                    <button class="btn btn btn-next btn-primary" @click="resetCouponCodeDiscount">Reset</button>
                </b-col> -->
              </b-row>
            </b-col>
          </b-row>          
          <!-- b-row>
            <b-col cols="8">
              <b-form-group label="Duration" description="Months">
                <b-form-input
                  v-model="$v.duration.$model"
                  type="number"
                  min="1"
                  max="100"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row -->
        </b-col>
      </b-row>

      <div>
        <div class="flex-grow-1 d-flex align-items-center justify-content-center flex-flow-column">
          <button class="btn btn btn-next" @click="applyCouponCodeDiscount" :disabled="isDisabledApplyBtn">Apply</button>
          <button class="btn btn btn-next" @click="resetCouponCodeDiscount" :disabled="isResetCouponCode">Reset</button>
        </div>
      </div>

      <div v-if="this.$store.state.job_offer">
        <div class="flex-grow-1"></div>
        <div class="flex-grow-1 d-flex align-items-center justify-content-center flex-flow-column">
          <b-button @click="completeOrder" class="btn btn-next">
            <template v-if="!completeLoading">Complete order</template>
            <template v-else>
              <b-spinner small />
            </template>
          </b-button>
          <b-button class="btn btn-next" @click="handleCancel">
            Cancel
          </b-button>
        </div>
        <div
          class="flex-grow-1 d-flex align-items-center justify-content-center v2_font_size_28"
        >
          <span class="v2_color_med_gray">Total:</span>&nbsp;
          <span class="v2_color_primary_teal">${{ this.total }}</span>
        </div>
      </div>
      <!---  Payment Success Modal -->
      <b-modal
        v-if="completeOrderModalVisible"
        lazy
        size="lg"
        hide-header-close
        header-class="v2_bg_primary_teal"
        modal-class="font_Montserrat"
        :visible="completeOrderModalVisible"
        hide-footer
      >
        <template slot="modal-header">
          <span
            class="align-self-center my-0 v2_color_white v2_font_weight_semibold v2_font_size_24"
          >
            Payment Success! 
          </span>
        </template>
        <b-row class="center-align-box margin-30">
          <b-col md="6" sm="12"  class="text-center mt-10">
              <b-button class="post_opportunity_btn h-100 max-height-150" variant="v2_primary pt-2 pb-4" @click="goToPage('dashboard')">
              <p class="font_weight_semibold v2_font_size_20">Go To Dashboard</p>
              <p>to Monitor and Manage candidates for your Job Opportunity.</p>
              </b-button>
          </b-col>

          <b-col md="6" class="text-center mt-10">
              <b-button class="post_opportunity_btn max-height-150" variant="v2_primary pt-2 pb-4 h-100" @click="goToPage('inform')">
              <p class="font_weight_semibold v2_font_size_20">Go to Inform </p>
              <p>to assess specialty productivity and compensation data and refine your Job Opportunity</p>
              </b-button>
          </b-col>
        </b-row>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { alphaSpaceValidator } from '@/helpers/customValidators';
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import { loadStripe } from '@stripe/stripe-js';

export default {
  name: 'PurchaseModal',
  mixins: [validationMixin],
  stripe: null,
  elements: null,
  cardNumberElement: null,
  cardCvvElement: null,
  cardExpiry: null,
  data: function () {
    return {
      total: 0,
      cardHolderName: null,
      stripeErrors: null,
      cs: null,
      completeLoading: false,
      duration: 3,
      jobOfferId:0,
      completeOrderModalVisible:false,
      job_opportunity_duration:0,
      couponCode:'',
      jobOfferPrice:0,
      isDisabledApplyBtn: false,
      isApplyCouponCode:false,
      isResetCouponCode:true,
      coupon_code_id:null
    };
  },
  validations: {
    cardHolderName: {
      required,
      alphaSpaceValidator,
    },
    duration: {},
  },
  mounted: async function () {
    this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);
    this.elements = this.stripe.elements();

    this.cardNumberElement = this.elements.create('cardNumber');
    this.cardNumberElement.mount(this.$refs.cardNumber, {});
    this.cardNumberElement.on('change', (event) => this.setOutcome(event));

    this.cardCvvElement = this.elements.create('cardCvc');
    this.cardCvvElement.mount(this.$refs.cardCvc, {});

    this.cardExpiry = this.elements.create('cardExpiry');
    this.cardExpiry.mount(this.$refs.cardExpiry, {});

    const jobOpportunityPrice = await Api.getSettingByKey('job_opportunity_price');
    this.total = this.jobOfferPrice = jobOpportunityPrice.value ? jobOpportunityPrice.value : 500;

    const jobOpportunityDuration = await Api.getSettingByKey('job_opportunity_duration');
    this.job_opportunity_duration = jobOpportunityDuration.value ? jobOpportunityDuration.value : 90;

  },
  computed: {
    cardHolderNameInvalidFeedback: function () {
      if (!this.$v.cardHolderName.alphaSpaceValidator) {
        return 'Only alpha characters are allowed';
      }
      return 'Card Holder Name is required';
    },
  },
  methods: {
    validateState: function (name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    setOutcome: function (result) {
      if (result.error) {
        this.stripeErrors = result.error.message;
      } else {
        this.stripeErrors = null;
      }
    },
    applyCouponCodeDiscount: async function() {
      try {
        const offerPrice = this.total;
        const couponData = await Api.getCouponDiscountIfExist(this.couponCode,offerPrice);
        this.total = couponData.coupon_discount;
        this.coupon_code_id = couponData.coupon_code_id;
        this.isDisabledApplyBtn=true;
        this.isApplyCouponCode=true;
        this.isResetCouponCode=false;
      }catch (error) {
        this.couponCode = '';
        this.isApplyCouponCode=false;
        handleServerErrorWithValidation(error, this.$toasted);
      }
    },
    resetCouponCodeDiscount() {
      this.couponCode = '';
      this.isApplyCouponCode=false;
      this.isResetCouponCode=true;
      this.total = this.jobOfferPrice;
      this.isDisabledApplyBtn=false;
    },
    completeOrder: async function () {
      this.stripeErrors = null;
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }

      this.completeLoading = true;

      const options = {
        name: this.cardHolderName,
      };

      try {
        const result = await this.stripe.createToken(
          this.cardNumberElement,
          options
        );
        if (result.error) {
          this.setOutcome(result);
          return;
        }
        
        ///// Save Job into Database ///////
        try {
          const keyMapping = {
          "title": "title",
          "description": "description", // Here, the typo in the key is retained as "descriotn" as per your requirement.
          "tracking": "tracking_num", // Renaming "tracking" to "tracking_nume"
          "jobBoardUrl": "external_url", // Renaming "jobBoardUrl" to "external_url"
          "company": "company_name", // Renaming "company" to "company_name"
          //"zipCode": "location_zip_code", // Renaming "zipCode" to "job_location_pincode"
          "welcome_message": "welcome_message", // Retaining the same key "welcome_message"
          "practice_name":"practice_name"
        };

        // function transformAndMergeData(jobInformation, jobOffer, jobOpportunityDuration, jobOfferPrice,couponCode) {
        //   // Transform jobInformation data using the key mapping
        //   const transformedData = Object.fromEntries(
        //     Object.entries(jobInformation).map(([oldKey, value]) => [keyMapping[oldKey] || oldKey, value])
        //   );
        //   const firstElementValue = jobOffer[0].value;
        //   const secondElementValue = jobOffer[1].value;
        //   const modifiedFirstElementValue = {
        //   ...firstElementValue,
        //   ...secondElementValue,
        //     subspecialty_id: firstElementValue.subspecialtyId,
        //     specialty_id: firstElementValue.specialtyId,
        //     job_offer_duration: jobOpportunityDuration,
        //     job_offer_price: jobOfferPrice,
        //     coupon_code: couponCode
        //   };
        //   // Merge the first element's "value" key from jobOffer with transformedData
          
        //   //const mergedData = { ...transformedData, ...firstElementValue };
        //   const mergedData = { ...transformedData, ...modifiedFirstElementValue };

          
        //   //mergedData.jobQuestions = jobOffer.filter(item => item.type !== "JOB_INFORMATION" && item.type !== "LOCATION" && item.type !== 'SPECIALTY' && item.type !== 'BOARD_CERTIFICATION' && item.type !== 'VISA_STATUS');
        //   mergedData.jobQuestions = jobOffer.filter(item => item.type !== "JOB_INFORMATION" && item.type !== "LOCATION" && item.type !== 'SPECIALTY');

        //   //console.log(JSON.stringify(mergedData));
        //   return mergedData;
        // }

        // Usage
        const jobInformation = this.$store.state.job_information;
        const jobOffer = this.$store.state.job_offer;
        const usedCouponCode = this.isApplyCouponCode ? this.couponCode : '';

        const data = this.transformAndMergeData(keyMapping,jobInformation, jobOffer, this.job_opportunity_duration, this.total,usedCouponCode);

        this.jobOfferId = await Api.createJobOfferData(data, 0);
          // this.resetValidation();
          // this[loadingVarName] = false;
          
        this.$store.state.job_offer = undefined;
        this.$store.state.job_information = undefined;
        this.$store.state.show_payment_page = '';
        this.$store.state.is_new_offer = undefined;
        this.$store.state.location_zip_code = undefined;
        this.$store.state.specialtyId = undefined;
          
        localStorage.removeItem('job_offer_signup_data');
        } catch (error) {
          handleServerErrorWithValidation(error, this.$toasted);
        } finally {
          // this[loadingVarName] = false;
          // this.createJobModalVisible = false;
        }

        const jobOffer = await Api.purchaseJobOffer(result.token.id, {
          amount: this.total,
          duration: this.duration,
          job_id : this.jobOfferId.id,
          coupon: (this.isApplyCouponCode) ? this.couponCode : '', 
        });

        this.$toasted.success('Job Offer created successfully', { duration: 3000 });
        this.$emit('job-offer-paid', jobOffer);
        this.completeOrderModalVisible=true;
        //this.$emit('updatePropValue', 5);
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.completeLoading = false;
      }
    },
    transformAndMergeData: function(keyMapping,jobInformation, jobOffer, jobOpportunityDuration, jobOfferPrice,couponCode) {
      // Transform jobInformation data using the key mapping
      const transformedData = Object.fromEntries(
        Object.entries(jobInformation).map(([oldKey, value]) => [keyMapping[oldKey] || oldKey, value])
      );
      const firstElementValue = jobOffer[0].value;
      const secondElementValue = jobOffer[1].value;
      const modifiedFirstElementValue = {
      ...firstElementValue,
      ...secondElementValue,
        subspecialty_id: firstElementValue.subspecialtyId,
        specialty_id: firstElementValue.specialtyId,
        job_offer_duration: jobOpportunityDuration,
        job_offer_price: jobOfferPrice,
        coupon_code: couponCode,
        payment_method:"card",
        coupon_code_id:this.coupon_code_id
      };
      // Merge the first element's "value" key from jobOffer with transformedData
      const mergedData = { ...transformedData, ...modifiedFirstElementValue };

      mergedData.jobQuestions = jobOffer.filter(item => item.type !== "JOB_INFORMATION" && item.type !== "LOCATION" && item.type !== 'SPECIALTY');

      return mergedData;
    },
    handleCancel: function () {
      //this.$emit('updatePropValue', 3);
      this.$store.state.job_offer=undefined;
      this.$store.state.is_change_criteria=undefined;
      this.$store.state.is_new_offer=undefined;
      this.$store.state.location_zip_code=undefined;
      this.$store.state.set_job_information = undefined;
      this.$store.state.specialtyId = undefined;
      this.$store.state.isComeFromIco = undefined;
      this.$store.state.is_change_criteria=undefined;
      this.$router.go(0); 
    },
    goToPage: function (page) {
        if(page=='inform')
        {
            this.$router.push('/recruiter/inform');
        }else{
            this.$router.push('/recruiter');
        }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/variables_mixins.scss';
.v2_bg_primary_teal {
  background-color: $phairify_v2_color_primary_teal;
}
.btn-next{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #99c555 !important;
  border: 1px solid #00586f !important;
  opacity: 1;
  max-width: 180px;
	width: 100%;
	justify-content: center;
	margin: 10px;
  border-radius: 0;
}
.btn-next:hover{
  background-color: #b0d27b !important;
}
.btn-next i{
  font-size:15px;
}
.btn-next:disabled{
  background-color:#DEE9EC !important;
  outline-color:rgba(77,88,88,0.5);
  border:1px solid #00586f !important;
  cursor: not-allowed;
}
.post_opportunity_btn{
  display: flex;
  align-items: center;
  flex-flow: column;
  height: unset;
}
.post_opportunity_btn p {
  line-height: 18px;
  margin-bottom: 0;
  padding-top: 20px;
}
.max-height-150{
    max-height: 150px;
}
.margin-30{
  margin: 30px;
}
.mt-10{
  margin-top:10px;
}
</style>
